import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { ToolbarWithBackAndDisableEditButtons } from '../common/Toolbar';
import Loading from '../common/Loading';
import { useRouter } from '../../context/router-context';
import { useContentDetailsQuery, UserRole } from '../../__generated__/graphql';
import ContentDetails from './ContentDetails';
import ContentDetailsPreview from './ContentDetailsPreview';
import { useViewer } from '../../context/viewer-context';
import { SignInScreen } from '../sign-in/sign-in';
import { useCollectActivity } from '../../hooks/analytics';
import { useRouteMatch } from 'react-router';
export function ContentDetailsData() {
    // Router
    var _a = useViewer(), viewer = _a.viewer, hasRole = _a.hasRole;
    var goForwardClick = useRouter().goForwardClick;
    var match = useRouteMatch();
    // State
    var _b = React.useState(0), progressTime = _b[0], setProgressTime = _b[1];
    // Analytics
    useCollectActivity('view', 'content', match.params.contentId);
    // const contentId = useRouteMatch<RouterParams>([
    //   '/content/:contentId',
    //   '/events/:eventId/content/:contentId',
    // ])?.params.contentId;
    // GraphQL query
    var _c = useContentDetailsQuery({
        variables: { id: match.params.contentId },
    }), data = _c.data, loading = _c.loading;
    var content = data && data.content;
    if (loading) {
        return (_jsxs(_Fragment, { children: [_jsx(ToolbarWithBackAndDisableEditButtons, {}, void 0),
                _jsx(Loading, {}, void 0)] }, void 0));
    }
    // "content" will be null for anonymous users if "public" is set to false,
    //  even if "previewUrl" is provided.
    if (!content) {
        return _jsx(SignInScreen, {}, void 0);
    }
    if ((content === null || content === void 0 ? void 0 : content.__typename) === 'ContentPreview') {
        // Handle if content.public is set to true, but "previewUrl" is not
        // provided
        if (!content.previewUrl) {
            return _jsx(SignInScreen, {}, void 0);
        }
        return (_jsx(ContentDetailsPreview, { contentId: content.id, url: content.previewUrl, type: content.type, title: content.title, description: content.description, onProgress: setProgressTime }, void 0));
    }
    if ((content === null || content === void 0 ? void 0 : content.__typename) === 'Content') {
        return (_jsx(ContentDetails, { contentId: content.id, url: content.url, type: content.type, title: content.title, description: content.description, createdBy: content.createdBy, isOwner: !!viewer && content.createdBy.id === viewer.id, isModerator: hasRole(UserRole.THOUGHT_LEADERSHIP__MODERATE), isPoster: hasRole(UserRole.THOUGHT_LEADERSHIP__POST), onForwardClick: goForwardClick('update'), startAt: progressTime }, void 0));
    }
    return null;
}
//# sourceMappingURL=ContentDetailsData.js.map